export default "__VITE_ASSET__BW69fD93__"